import {
    init,
    getContext,
    setContext,
    setActions,
    setAxiosDevices,
    loadFragment,
    dispatchEvent,
    cfmLogin,
    changeImplementation,
    getExternalKeys,
    externalLogin,
} from './backend.js';

export default {
    init,
    getContext,
    setContext,
    setActions,
    setAxiosDevices,
    loadFragment,
    dispatchEvent,
    cfmLogin,
    changeImplementation,
    getExternalKeys,
    externalLogin,
};

// export for ESM
export {
    init,
    getContext,
    setContext,
    setActions,
    setAxiosDevices,
    loadFragment,
    dispatchEvent,
    cfmLogin,
    changeImplementation,
    getExternalKeys,
    externalLogin,
};
